module.exports = __webpack_public_path__ + "img/game.8e4cafee.svg";